export const h = {
    "common": {
        "webSuffix": "QIDI Tech",
        "email": "postvak",
        "password": "wachtwoord",
        "verificationCode": "Verificatiecode",
        "username": "gebruikersnaam",
        "readAndAgree": "Ik ben het ermee eens",
        "and": "en",
        "userAgreement": "Gebruikersovereenkomst",
        "privacyPolicy": "Privacybeleid",
        "copy": "copyright ©  Vanaf 2025 behoudt Di zich het eigendom voor",
        "sendVerificationCode": "Verificatiecode verzenden",
        "Sending": "Verzenden",
        "tryAgainInSeconds": "Probeer het opnieuw in seconden",
        "userNameRequired": "Voer één gebruikersnaam in",
        "passwordInputLabel": "Voer een wachtwoord in",
        "checkPasswordInputLabel": "Voer het bevestigingspawoord in",
        "userEmailRequired": "Vul uw e-mailadres in",
        "userEmailInvalid": "Voer het juiste e-mailadres in",
        "emailCodeRequired": "Voer de verificatiecode in",
        "newPasswordInputLabel": "Voer een nieuw wachtwoord in",
        "confirmPasswordInputLabel": "Voer uw wachtwoord opnieuw in",
        "passwordMismatchErrorLabel": "Het tweemaal ingevoerde wachtwoord is inconsistent",
        "agreementRequired": "Lees en ga akkoord met de overeenkomst",
        "tip": "Tips",
        "tipAlreadyLogin": "Ontdekt dat u bent ingelogd, doorgestuurd naar het gebruikerscentrum voor u",
        "tipWelcomeBack": "Welkom terug~",
        "tipDeleteAccountFail": "Het verwijderen van account is mislukt, de interface voor het verwijderen van account is tijdelijk gesloten",
        "pleaseAgreeFirst": "Gelieve eerst akkoord te gaan",
        "agree": "akkoord gaan",
        "refuse": "weigeren",
        "tipNeedLogin": "Gelieve eerst in te loggen",
        "tipChangePasswordSuccess": "Wachtwoord succesvol gewijzigd, we zullen u doorverwijzen naar de inlogpagina",
        "tipGetUserInfoSuccess": "Succesvol verkregen informatie",
        "tipGetUserInfoFail": "het verkrijgen van informatie mislukt",
        "tipLoginOut": "Log uit en log in",
        "delete": "verwijderen",
        "back": "terugkeer",
        "init": "initialisatie",

        "passwordInputLengthErrorLabel": "De wachtwoordlengte moet tussen 6 en 20 liggen",
        "changePasswordFail": "Origineel wachtwoord onjuist",
        "tipDeleteAccountSuccess": "Account succesvol verwijderd",
        "emailCodeSentSuccess": "De verificatiecode is afgegeven",
        "emailCodeSentFail": "Afgifte van verificatiecode mislukt",
        "emailLoginFail": "De verificatiecode is verlopen",
        "passwordLoginFail": "Login wachtwoord onjuist",
        "editUserInfoSuccess": "Met succes gewijzigde gebruikersinformatie",
        "registerSuccess": "succesvol geregistreerd",
        "registerFail": "aanmelding is mislukt",
        "registerEmailExistFail": "E-mail bestaat al",

        "resMessageTip0": "onbekende informatie",
        "resMessageTip1": "Wachtwoord fout",
        "resMessageTip2": "De wachtwoordlengte moet tussen 6 en 20 liggen",
        "resMessageTip3": "Accountfout",
        "resMessageTip4": "De verificatiecode is afgegeven",
        "resMessageTip5": "Afgifte van verificatiecode mislukt",
        "resMessageTip6": "De verificatiecode is verlopen",
        "resMessageTip7": "Wachtwoord fout",
        "resMessageTip8": "Het wachtwoord kan niet hetzelfde zijn als het oude wachtwoord",
        "resMessageTip9": "E-mail bestaat al",
        "resMessageTip10": "succesvol geregistreerd",
        "resMessageTip11": "aanmelding is mislukt",
        "resMessageTip12": "Met succes gewijzigde gebruikersinformatie",
        "resMessageTip13": "Wijziging van gebruikersinformatie mislukt",
        "resMessageTip14": "Succesvol verkregen",
        "resMessageTip15": "Verwerving mislukt",
        "resMessageTip16": "Wachtwoord succesvol gewijzigd",
        "resMessageTip17": "Wachtwoord wijzigen mislukt",
        "resMessageTip18": "Wachtwoord resetten succesvol",
        "resMessageTip19": "Wachtwoord resetten mislukt",
        "resMessageTip20": "Inloggen succesvol",
        "resMessageTip21": "Inloggen mislukt",
        "resMessageTip22": "Account succesvol verwijderd",
        "resMessageTip23": "Verwijderen van account mislukt",
        "resMessageTip24": "De verificatiecode is onjuist",
        "noUserInfoError": "Netwerkfout, logt u opnieuw in"
    },
    "changePassword": {
        "newPassword": "Nieuw wachtwoord"
    },
    "deleteUser": {
        "tipDeleteUser": "Helaas moet je vertrekken. Zodra uw account is verwijderd, zullen al uw persoonlijke gegevens voorgoed verdwijnen en kunnen ze niet worden hersteld.",
        "accountDeletionTerms": "Voorwaarden voor het verwijderen van accounts"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Wachtwoord ophalen via e-mail",
        "confirmPassword": "Wachtwoord bevestigen",
        "resettingPassword": "wachtwoord opnieuw instellen",
        "resetting": "Reset"
    },
    "login": {
        "passwordLogin": "Wachtwoord inloggen",
        "verifyLogin": "Login verifiëren",
        "accountRegistration": "Registratie van de rekening",
        "forgotPassword": "Wachtwoord vergeten",
        "login": "Inloggen",
        "localLogin": "Lokale aanmelding",
        "loginOut": "Uitloggen",
        "continueOnYourWay": "Ga verder op je weg"
    },
    "register": {
        "registerAnAccount": "Een account aanmaken",
        "register": "register"
    },
    "userCenter": {
        "personalInformation": "persoonsgegevens",
        "modifyInformation": "Informatie wijzigen",
        "changePassword": "Wachtwoord wijzigen",
        "cancelAccount": "Account annuleren",
        "exitAccount": "Afsluitrekening",
        "change": "wijzigen",
        "maxCharLimitTip": "De lengte van de gebruikersnaam mag niet groter zijn dan 10 Chinese tekens",
    },
    "policies": {
        "deleteAccountPrivacy": "Accountovereenkomst verwijderen",
        "agreement": "Gebruiksovereenkomst",
        "privacyPolicy": "Privacybeleid"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Kies uw land of regio",
        "recommendedVisits": "Aanbevolen bezoek",
        "NorthAmerica": "Noord-Amerika",
        "Europe": "Europa",
        "Asia": "Azië",
        "Other": "andere",
    }
}

export const aAndL ={
    "ar": {
        "Country": "arab",
        "Language": "Arabisch"
    },
    "cs": {
        "Country": "Tsjechië",
        "Language": "Tsjechisch"
    },
    "de": {
        "Country": "Duitsland",
        "Language": "Duits"
    },
    "en": {
        "Country": "Britain",
        "Language": "Engels"
    },
    "es": {
        "Country": "Spanje",
        "Language": "Spaans"
    },
    "fr": {
        "Country": "Frankrijk",
        "Language": "Frans"
    },
    "he": {
        "Country": "Israël",
        "Language": "Hebreeuws"
    },
    "hu": {
        "Country": "Hongarije",
        "Language": "Hongaarse taal"
    },
    "it": {
        "Country": "Italië",
        "Language": "Italiaans"
    },
    "ja": {
        "Country": "Japan",
        "Language": "Japans"
    },
    "ko": {
        "Country": "de republiek Korea",
        "Language": "Koreaans"
    },
    "nl": {
        "Country": "Nederland",
        "Language": "Nederlands"
    },
    "pt": {
        "Country": "Portugal",
        "Language": "Portugees"
    },
    "pt_BR": {
        "Country": "Portugal (Brazilië)",
        "Language": "Portugees (Brazilië)"
    },
    "ru": {
        "Country": "Rusland",
        "Language": "Russisch"
    },
    "sv": {
        "Country": "Zweden",
        "Language": "Zweedse taal"
    },
    "tr": {
        "Country": "Türkiye",
        "Language": "Turks"
    },
    "uk": {
        "Country": "Oekraïne",
        "Language": "Oekraïense taal"
    },
    "zh": {
        "Country": "Chinees vasteland",
        "Language": "Vereenvoudigd Chinees"
    },
    "zh_tw": {
        "Country": "Taiwan, China",
        "Language": "Traditioneel Chinees"
    },
    "Canada": {
        "Country": "Canada",
        "Language": "Engels"
    },
    "United_States": {
        "Country": "V.S.A.",
        "Language": "Engels"
    },
    "United_Kingdom": {
        "Country": "Britain",
        "Language": "Engels"
    },
    "EU_Countries": {
        "Country": "EU-landen",
        "Language": "Engels"
    },
    "Australia": {
        "Country": "Australië",
        "Language": "Engels"
    },
    "globalzh": {
        "Country": "Globaal",
        "Language": "Vereenvoudigd Chinees"
    },
    "globalen": {
        "Country": "Global",
        "Language": "Engels"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/nl.js